// extracted by mini-css-extract-plugin
export var readonly = "_iy-1";
export var star = "_iy-0";